import type { MeResponse, ProgressResponse } from '@devlearn/shared';
import type { ReactNode } from 'react';
import { formatNumber, plural } from '@/lib/format';
import { WeekActivity } from './WeekActivity';

function StatTile({ label, value, sub }: { label: string; value: ReactNode; sub: ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5 rounded-xl border border-line bg-surface px-6 py-5">
      <span className="text-sm text-ink-muted">{label}</span>
      <span className="font-display text-[30px] font-semibold leading-tight tabular-nums">{value}</span>
      <span className="text-meta text-ink-muted">{sub}</span>
    </div>
  );
}

type StatTilesProps = { me: MeResponse; progress: ProgressResponse; today: string; trackTitle: string };

export function StatTiles({ me, progress, today, trackTitle }: StatTilesProps) {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
      <StatTile
        label="Current streak"
        value={plural(me.streak.current, 'day')}
        sub={`${plural(me.streak.freezesLeft, 'streak freeze')} left`}
      />
      <StatTile
        label="XP this week"
        value={formatNumber(me.xp.thisWeek)}
        sub={`${formatNumber(me.xp.total)} total`}
      />
      <StatTile
        label="Challenges done"
        value={`${progress.totals.completed} / ${progress.totals.total}`}
        sub={trackTitle}
      />
      <div className="flex flex-col gap-2.5 rounded-xl border border-line bg-surface px-6 py-5">
        <span className="text-sm text-ink-muted">This week</span>
        <WeekActivity week={progress.week} today={today} />
      </div>
    </div>
  );
}
